export const ItemCard = ({ title, total, icon, bg }) => {
    return (
        <div className="flex-grow flex items-center bg-blue-50 border rounded overflow-hidden shadow min-w-[250px]">
            <div className={`${bg} p-4`}>
                <span
                    style={{ fontSize: "45px" }}
                    className="h-12 w-12 flex items-center justify-center text-white material-symbols-outlined">
                    {icon}
                </span>
            </div>
            <div className="px-4 text-gray-700">
                <h3 className="text-sm tracking-wider">{title}</h3>
                <p
                    className="text-xl font-bold overflow-hidden text-ellipsis whitespace-nowrap"
                    style={{
                        fontSize: "clamp(1rem, 2vw, 1.5rem)",
                    }}>
                    {total}
                </p>
            </div>
        </div>
    );
};
